import { syncStatusRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';

const SYNC_STATUS_QUERY_KEY = ['sync', 'status'];

export const useGetSyncStatus = () =>
  useQuery({
    queryKey: SYNC_STATUS_QUERY_KEY,
    queryFn: () => syncStatusRepo.getLastSuccessfulSyncAt(),
    staleTime: 60000,
    refetchInterval: 60000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
